'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { persistQueryClient } from '@tanstack/react-query-persist-client';
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import { useState } from 'react';

const MAX_DATA_AGE = 1000 * 3 * 60; // 3 minuty

export function ReactQueryProvider({ children }: { children: React.ReactNode }) {
  const [client] = useState(() => {
    const queryClient = new QueryClient({
      defaultOptions: {
        queries: {
          staleTime: MAX_DATA_AGE,
          refetchOnMount: false,
          refetchOnWindowFocus: false,
          refetchOnReconnect: false,
          retry: 2,
        },
      },
    });

    const localStoragePersister = createSyncStoragePersister({
      storage: typeof window !== 'undefined' ? window.localStorage : undefined,
    });

    persistQueryClient({
      queryClient,
      persister: localStoragePersister,
      maxAge: MAX_DATA_AGE,
      buster: 'v1', // version for cache busting
      dehydrateOptions: {
        shouldDehydrateQuery: (query) => {
          return Array.isArray(query.queryKey) && query.queryKey.includes('persisted');
        },
      },
    });

    return queryClient;
  });

  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}
